// @flow

import './index.scss';
import * as React from 'react';
import classnames from 'classnames';
import { useTranslate } from '@insolus/react-i18n';
import Spinner from '../Spinner';

type Props = {|
    text: string | boolean,
    waitTime: number,
    overlay?: boolean
|};

const Loading = ({
    text: _text,
    waitTime,
    overlay
}: Props): React.Node => {
    const { __ } = useTranslate();
    const [display, setDisplay] = React.useState<boolean>(false);

    React.useEffect((): * => {
        const displayRender = () => {
            setDisplay(true);
        };
        const displayTimeout = setTimeout(displayRender, waitTime);

        return () => { clearTimeout(displayTimeout); };
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    if (!display) {
        return null;
    }

    const text = _text === true ? __('loading') : _text;

    const _classnames = classnames('Loading', {
        'Loading--text'    : !!text,
        'Loading--overlay' : !!overlay
    });

    return (
        <div className={_classnames}>
            {text && <span className="Loading__text">{text}</span>}
            <Spinner />
        </div>
    );
};

Loading.defaultProps = {
    text     : true,
    waitTime : 300,
    overlay  : false
};

export default Loading;
